var map = {
	"./active.svg": "55c0",
	"./cancel.svg": "0a7d",
	"./delete.svg": "1d64",
	"./disabled.svg": "4f51",
	"./favorites.svg": "1e53",
	"./hide.svg": "830c",
	"./members.svg": "911a",
	"./menu.svg": "15d0",
	"./open.svg": "1f25"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f95e";